import React from 'react';
import styles from './BetTableTeen9.module.css';

const BetTableTeen9 = ({ data = [], exposures = {}, min = "10.0", max = "100K" }) => {
  // Bet types mapping to indices in subData array
  // Tiger: indices 0-5, Lion: indices 6-11, Dragon: indices 12-17
  const betTypes = [
    { type: "Winner", indices: [0, 6, 12] },
    { type: "Pair", indices: [1, 7, 13] },
    { type: "Flush", indices: [2, 8, 14] },
    { type: "Straight", indices: [3, 9, 15] },
    { type: "Trio", indices: [4, 10, 16] },
    { type: "Straight Flush", indices: [5, 11, 17] },
  ];

  // Get exposure value - try different key formats to match API team_name
  const getExposure = (nat) => {
    if (!nat) return 0;

    const exposureKeys = [
      nat, // "Tiger Winner"
      nat.replace(/\s+/g, " "), // Normalized spacing
      nat.toLowerCase(),
      nat.toLowerCase().trim(),
      nat.trim(),
    ];

    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined) {
        return parseFloat(exposures[key]) || 0;
      }
    }
    return 0;
  };

  // Check if a bet is suspended
  const isSuspended = (apiData) => {
    if (!apiData) return true;
    const status = apiData.gstatus?.toUpperCase();
    const odds = apiData.b;
    return status === "SUSPENDED" || !odds || odds === 0 || odds <= 0;
  };

  // Render bet cell (admin version - no click handler, just display)
  const renderBetCell = (betData, selection) => {
    const suspended = isSuspended(betData);
    const value = betData?.b || 0;
    const exposure = getExposure(selection);
    const displayExposure = exposure !== 0 ? (exposure < 0 ? exposure.toFixed(0) : `+${exposure.toFixed(0)}`) : "0";

    return (
      <td
        className={`${styles.back} ${styles.textCenter} ${styles.box2} ${suspended ? styles.teenpattiSuspended : ""}`}
        style={{ 
          cursor: 'default', 
          position: "relative", 
          backgroundColor: suspended ? "rgba(217, 220, 223)" : "#72bbef" 
        }}
      >
        <div style={{ fontWeight: "bold", fontSize: "14px", color: "#000" }} className={`d-block ${styles.odds}`}>{value}</div>
        <div 
          style={{ 
            fontWeight: "bold", 
            fontSize: "10px",
            color: exposure !== 0 ? (exposure < 0 ? '#ff0000' : '#00ff00') : '#000'
          }} 
          className="d-block"
        >
          {displayExposure}
        </div>
      </td>
    );
  };

  return (
    <div className={`teenpatti-wrapper table-responsive ${styles.teenpattiWrapper}`}>
      <table className="table table-bordered m-b-0">
        <thead>
          <tr style={{ backgroundColor: "#72bbef" }}>
            <th style={{ backgroundColor: "#72bbef", padding: "8px", fontWeight: "bold" , color: "#000", fontSize: "14px", width: "20%"}} className={`${styles.textCenter} ${styles.back} ${styles.headerBack}`}>Back</th>
          </tr>
          <tr style={{ backgroundColor: "#72bbef" }}>
            <th className={`${styles.box4} ${styles.emptyHeader}`} style={{ borderTop: "0px" }}></th>
            <th style={{ fontWeight: "bold", fontSize: "12px", color: "#000", backgroundColor: "#72bbef", padding: "8px" }} className={`${styles.textCenter} ${styles.back} ${styles.box2} ${styles.columnHeader}`}>TIGER</th>
            <th style={{ fontWeight: "bold", fontSize: "12px", color: "#000", backgroundColor: "#72bbef", padding: "8px" }} className={`${styles.textCenter} ${styles.back} ${styles.box2} ${styles.columnHeader}`}>LION</th>
            <th style={{ fontWeight: "bold", fontSize: "12px", color: "#000", backgroundColor: "#72bbef", padding: "8px" }} className={`${styles.textCenter} ${styles.back} ${styles.box2} ${styles.columnHeader}`}>DRAGON</th>
          </tr>
        </thead>
        <tbody>
          {betTypes.map((row, rowIndex) => {
            const tigerData = data[row.indices[0]] || {};
            const lionData = data[row.indices[1]] || {};
            const dragonData = data[row.indices[2]] || {};

            return (
              <tr key={rowIndex}>
                <td style={{ fontWeight: "900", fontSize: "14px", backgroundColor: "transparent", color: "#fff" }} className={`${styles.box4} ${styles.playerName}`}>
                  <div>{row.type}</div>
                </td>
                {renderBetCell(tigerData, tigerData?.nat || `Tiger ${row.type}`)}
                {renderBetCell(lionData, lionData?.nat || `Lion ${row.type}`)}
                {renderBetCell(dragonData, dragonData?.nat || `Dragon ${row.type}`)}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BetTableTeen9;

